








import Modal from "../core/Modals/Modal";
import InterventionReassignDateEdit from "./InterventionReassignDateModalPartials/InterventionReassignDateEdit.vue";

export default {
    name: "InterventionReassignDateModal",
    components: { InterventionReassignDateEdit, Modal },
    props: {
        interventions: Array,
        showModal: Boolean,
    },
    methods: {
        closeModal(): void {
            this.$emit("close-modal");
        },
    },
};
